/**
 * 에러메세지 모음
 */
export default {
  'auth': {
    'failed-to-login': '@:terms.auth.login에 @:terms.failed 하였습니다.',
  },
}
